import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import COOKIES from '~/constants/cookies';
import {
  useConfiguration,
  useEventCorrelationId
} from '~/context/common/StaticContext';
import { useIsLoggedIn, useUserId } from '~/context/common/UserContext';
import BrowserCookies from '~/utilities/BrowserCookies';
import initDataDog from '~/utilities/datadog';

function checkIsSampled(): boolean {
  const isNotSampled =
    BrowserCookies.get(COOKIES.dataDogSampling)?.includes('rum=0') ?? false;

  return !isNotSampled;
}

export function calculateRecordingType(
  userId: string,
  dataDogRecordingSampleRate: number
): number {
  const lastChars = userId.slice(-3);
  const unHexedNumber = parseInt(lastChars, 16);
  const moddedNumber = unHexedNumber % 100;

  return moddedNumber <= dataDogRecordingSampleRate ? 1 : 2;
}

function useRecordingType(): number {
  const userId = useUserId();
  const { dataDogRecordingSampleRate = 0 } = useConfiguration();

  return calculateRecordingType(userId, dataDogRecordingSampleRate);
}

export default function useDataDogRUM(forceSampleRate?: number) {
  const eventCorrelationId = useEventCorrelationId();
  const { dataDogSampleRate } = useConfiguration();
  const isLoggedIn = useIsLoggedIn();
  const recordingType = useRecordingType();
  const sampleRate = forceSampleRate ?? dataDogSampleRate;

  useSubsequentEffect(() => {
    if (!isLoggedIn || checkIsSampled()) return;

    BrowserCookies.set('_dd_s', `rum=${recordingType}`);

    initDataDog(eventCorrelationId, sampleRate);
  }, [eventCorrelationId, isLoggedIn, recordingType, sampleRate]);
}
